<template>
    <!-- The region stays mounted and only its text changes; an aria-label on a region that
         appears together with its spinner is never announced. -->
    <output :aria-label="t('components.fullPageLoading.label')" aria-atomic="true">
        <div v-if="loading" class="fixed top-0 left-0 z-9999 flex h-screen w-screen items-center justify-center bg-surface-raised/60 backdrop-blur-sm">
            <LoadingSpinner class="h-16 text-ink-muted" />
            <span class="sr-only">Page loading</span>
        </div>
    </output>
</template>

<script setup lang="ts">
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<script lang="ts">
const loading = ref(false);
export function showFullPageLoading() {
    loading.value = true;
}
export function hideFullPageLoading() {
    loading.value = false;
}
</script>
